module.exports = __webpack_public_path__ + "img/shlk.90ca0e94.jpg";